import React from 'react';
import { FormHelperText } from '@material-ui/core';
import { FieldError } from 'react-hook-form';
import { MAX_HEIGHT, MAX_WEIGHT } from './rideFormComponents/constants';

interface WeightErrorProps {
  fieldError: FieldError | undefined;
  weight?: number;
  metric?: 'lbs' | 'kg';
}

export const WeightError: React.FC<WeightErrorProps> = ({
  fieldError,
  weight = MAX_WEIGHT,
  metric,
}) => {
  if (!fieldError) {
    return null;
  }

  if (fieldError.type === 'required' || fieldError.type === 'min') {
    return (
      <FormHelperText error>
        Weight value must be greater than 0 {metric}
        <br />
        Please call 1-800-700-4797
      </FormHelperText>
    );
  }

  if (fieldError.type === 'max') {
    return (
      <FormHelperText error>
        Weight must be less than {weight} {metric}
        <br />
        Please call 1-800-700-4797
      </FormHelperText>
    );
  }

  return null;
};

interface HeightErrorProps {
  fieldError: FieldError | undefined;
  height?: number;
  metric?: 'in' | 'cm';
}

export const HeightError: React.FC<HeightErrorProps> = ({
  fieldError,
  height = MAX_HEIGHT,
  metric = 'in',
}) => {
  if (!fieldError) {
    return null;
  }

  if (fieldError.type === 'required' || fieldError.type === 'min') {
    return (
      <FormHelperText error>
        Height value must be greater than 0 {metric}
        <br />
        Please call 1-800-700-4797
      </FormHelperText>
    );
  }

  if (fieldError.type === 'max') {
    return (
      <FormHelperText error>
        Height should be less than {height} {metric}
      </FormHelperText>
    );
  }

  return null;
};
